// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, PropTypes, classNames } from '@plesk/ui-library';

/**
 * `TextEditor` component.
 * @since 0.0.48
 */
class TextEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: this.props.value || this.props.children,
        };
    }

    componentDidMount() {
        const { onInit } = this.props;
        if (onInit) {
            onInit(this.textareaNode);
        }
    }

    componentWillReceiveProps({ value, children }) {
        const newContent = value || children;
        if (this.props.onChange && newContent !== this.state.content) {
            this.setState({ content: newContent });

            this.textareaNode.setValue(newContent);
        }
    }

    shouldComponentUpdate({ value, children }) {
        const newContent = value || children;
        if (newContent === this.state.content) {
            return false;
        }

        return true;
    }

    handleChange = event => {
        if (this.props.readonly) {
            return;
        }

        const content = event.target.value;
        this.setState({ content }, () => {
            const { onChange } = this.props;
            if (onChange) {
                onChange(content);
            }
        });
    };

    handleKeyDown = event => {
        const ctrlOrMetaKeyPressed = (event.ctrlKey && !event.metaKey) || (event.metaKey && !event.ctrlKey);

        if (event.key.toLowerCase() === 's'
            && ctrlOrMetaKeyPressed
            && !event.shiftKey
            && !event.altKey
        ) {
            event.preventDefault();
            this.props.onSave();
        }
    };

    render() {
        const {
            className,
            readonly,
            ...props
        } = this.props;

        const { content } = this.state;

        delete props.children;
        delete props.value;
        delete props.onChange;

        return (
            <textarea
                ref={ref => (this.textareaNode = ref)}
                className={classNames('file-manager__text-editor', className)}
                defaultValue={content}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
                readOnly={readonly}
                {...props}
            />
        );
    }
}
TextEditor.propTypes = {
    /**
     * Content of the `TextEditor`.
     */
    children: PropTypes.any,
    /**
     * Alternative method of setting content
     */
    value: PropTypes.string,
    /**
     * Additional class name.
     */
    className: PropTypes.string,
    /**
     * Is not allowed to edit content
     */
    readonly: PropTypes.bool,
    onInit: PropTypes.func,
    /**
     * onChange event handler
     */
    onChange: PropTypes.func,
    /**
     * on save event handler
     */
    onSave: PropTypes.func.isRequired,
};
TextEditor.defaultProps = {
    children: '',
    value: '',
    className: '',
    readonly: false,
    onInit: null,
    onChange: null,
};

export default TextEditor;



// WEBPACK FOOTER //
// ./views/smb/file-manager/TextEditor.js